// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"532dd50d","812":"ad4878cc","900":"82f8798e","969":"5221eae4"}[chunkId] + ".chunk.js";
};